import React from 'react';
import './background.css';

interface Props {
  imageUrl: string;
}

const FullScreenBackground: React.FC<Props> = ({ imageUrl }) => {
  return (
    <div
      className="full-screen-bg"
      style={{ ['--bg-image' as any]: `url(${imageUrl})` }}
    />
  );
};

export default FullScreenBackground;
